import { MutationTree } from 'vuex';
import { State } from '@/store/modules/cloud/connections/services.store';
import {
  ADD_NEW_CONNECTION,
  CURRENT_API_STATUS,
  REMOVE_CONNECTION_MUTATION,
  SET_ALL_CONNECTIONS,
  SET_ERROR_MESSAGE,
  UPDATE_EDITED_CONNECTION,
  UPDATE_SEARCH_SERVICE,
} from '@/store/modules/cloud/connections/services.constants';

const servicesMutation: MutationTree<State> = {
  [SET_ALL_CONNECTIONS](state, data) {
    state.allConnections = data;
  },
  [ADD_NEW_CONNECTION](state, data) {
    state.allConnections = [...state.allConnections, data];
  },
  [UPDATE_EDITED_CONNECTION](state, data) {
    state.allConnections = state.allConnections.map((service) => {
      if (service.subscriptionId === data.subscriptionId) {
        return { ...data, services: service.services };
      }
      return { ...service };
    });
  },
  [REMOVE_CONNECTION_MUTATION](state, subscriptionId) {
    state.allConnections = state.allConnections.filter(
      (service) => service.subscriptionId !== subscriptionId,
    );
  },
  [CURRENT_API_STATUS](state, apiStatus) {
    state.apiCallStatus = apiStatus;
  },
  [SET_ERROR_MESSAGE](state, errorMessage) {
    state.errorMessage = errorMessage;
  },
  [UPDATE_SEARCH_SERVICE](state, searchedService) {
    state.searchedService = searchedService;
  }
};

export default servicesMutation;
